import { render } from "./PpcSPProductAds.vue?vue&type=template&id=e3fa7614&scoped=true"
import script from "./PpcSPProductAds.vue?vue&type=script&lang=js"
export * from "./PpcSPProductAds.vue?vue&type=script&lang=js"

import "./PpcSPProductAds.vue?vue&type=style&index=0&id=e3fa7614&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3fa7614"]])

export default __exports__